import { BaseEcomSdkEnumsObj } from "@payair/e-com-common-sdk/models/BaseEcomSdkEnum";
export const EcomWalletSdkEnumsObj = {
    PAYAIR_APPLE_PAY_SDK: BaseEcomSdkEnumsObj.PAYAIR_APPLE_PAY_SDK,
    PAYAIR_GOOGLE_PAY_SDK: BaseEcomSdkEnumsObj.PAYAIR_GOOGLE_PAY_SDK,
    PAYAIR_SAMSUNG_PAY_SDK: BaseEcomSdkEnumsObj.PAYAIR_SAMSUNG_PAY_SDK,
    PAYAIR_SRCI_SDK: BaseEcomSdkEnumsObj.PAYAIR_SRCI_SDK,
};
